import React, { lazy, Suspense } from 'react';
import Loader from '~/components/Loader/Loader';

// Lazy load CKEditor and Editor2Component
const Editor2Component = lazy(() =>
    import(/* webpackChunkName: "editor2" */ './Editor2Component')
);

const Editor2 = props => {
    return (
        <Suspense fallback={<Loader />}>
            <Editor2Component {...props} />
        </Suspense>
    );
};

// Export toolbars for backward compatibility
export { toolbars } from './toolbars';

export default Editor2;
